module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Medium_DK.3c22d9db.png";